@if (editing) {
  <app-tag-input
    class="tags-editor"
    [objectType]="objectType"
    [existingTags]="cell.tags ?? []"
    [compact]="true"
    [showChevron]="false"
    [autoOpen]="true"
    (tagsChanged)="onTagsChanged($event)"
    (menuClosed)="stopEditing()"
  ></app-tag-input>
} @else {
  <div class="tags-display" (click)="startEditing()">
    @if (cell.loaded && cell.tags?.length) {
      <motn-pill-list
        class="tags-pills"
        [items]="pillItems"
        [maxVisible]="15"
        [wrap]="true"
        [overlayPositions]="overlayPositions"
      ></motn-pill-list>
    } @else {
      <span class="tags-hint">Add tags…</span>
    }
  </div>
}
